export default class CardLinks {
  constructor() {
    $('.card.link').each(function() {
      const linkWrapper = document.createElement('a');
      linkWrapper.setAttribute('class', $(this).attr('class'));
      const link = $(this)
        .find('.card-link')
        .text();
      linkWrapper.setAttribute(
        'href',
        link.startsWith('http') ? link : DOC_URL + link
      );
      linkWrapper.innerHTML = this.innerHTML;
      $(this).replaceWith(linkWrapper);
    });
  }
}
